import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeUnderscore' })
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined) return '';
    
    const str = String(value);
    return str
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase())
      .replace(/\bLicenses\b/g, 'Licences')
      .replace(/\bLicense\b/g, 'Licence');
  }
}
